module.exports = __webpack_public_path__ + "img/council-bluffs-chiropractors.2d2d1b69.jpg";